import React from "react";
import { NavLink } from "react-router-dom";

export function NavigationLink(props) {
    return (
        <NavLink
            to={props.target}
            onClick={() => {
                // Used to let users click "Home" to scroll to top when already on the Home-page
                const anchor = document.querySelector("#top");
                anchor.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }}
            className={({ isActive }) =>
                [
                    "flex justify-center text-center text-[14px] line-clamp-2 items-center h-full cursor-pointer font-bold no-underline",
                    props.className,
                    isActive ? "!text-pine" : "text-white",
                ].join(" ")
            }
        >
            {props.content}
        </NavLink>
    );
}
